<template>
  <report-page
    :title="name"
    :preview-available="false"
    :data-to-send="dataToSend"
    :buttons-disabled="false"
    :report-parameters="reportParameters"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <!-- <report-field :field-name="$tc('IncludePhotos', 1)">
        <v-checkbox
          v-model="reportParameters[0].value"
          :label="reportParameters[0].label"
        />
      </report-field> -->
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "../../../../../../mixins/homeReportPageMixin";

export default {
  name: "KMLReport",
  components: {
    ReportField,
    ReportPage
  },
  mixins: [homeReportPageMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      reportParameters: [
        {
          label: "Photos",
          key: "photos",
          type: "checkbox",
          value: undefined
        }
      ],

      historyFilter: "kml"
    };
  },
  computed: {
    dataToSend() {
      let includePhotos = this.reportParameters[0].value;
      return {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace,
          object: [
            {
              uuid: "",
              object_type: ""
            }
          ],
          include_photos: includePhotos
        }
      };
    }
  },
  mounted() {
    this.setWorkspaceField();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/KML.vue